import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ClaimResponseListScreen } from 'screens/claim';

export default withPermissions(ClaimResponseListScreen, [
  GroupSecurity.ClaimResponseRead,
]);
